var _excluded = ["children", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { string, oneOf, func } from "prop-types";
import { Button } from "#library/components/Button";
import { MODAL_BUTTON_VARIANTS } from "./constants";
export var ModalButton = function ModalButton(props) {
  var children = props.children,
    variant = props.variant,
    restProps = _objectWithoutProperties(props, _excluded);

  // Prevent overload
  if (restProps.hasOwnProperty("className")) {
    delete restProps.className;
  }
  return /*#__PURE__*/React.createElement(Button, _extends({}, restProps, {
    variant: variant,
    "data-context": "FooterButton"
  }), children);
};
ModalButton.propTypes = {
  children: string.isRequired,
  variant: oneOf(Object.values(MODAL_BUTTON_VARIANTS)),
  onClick: func
};
ModalButton.defaultProps = {
  variant: MODAL_BUTTON_VARIANTS.REGULAR,
  onClick: null
};